import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {PrenotazioneAppuntamentoService} from "../../services/prenotazione-appuntamento.service";
import {Appuntamento} from "../../models/appuntamento";
import {JoyrideService} from 'ngx-joyride';
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import { UserData } from '../../models/user-data';
import { AccountService } from '../../core/auth/account.service';

@Component({
  selector: 'jhi-prenota-nuovo-appuntamento',
  templateUrl: './prenota-nuovo-appuntamento.component.html',
  styleUrls: ['./prenota-nuovo-appuntamento.component.scss']
})
export class PrenotaNuovoAppuntamentoComponent implements OnInit {

  appuntamento!: Appuntamento;
  isLoggedIn = false;
  codiceServizio: string | null = null;
  ufficio: string | null = null;

  constructor(public route: Router, private activatedRoute: ActivatedRoute, private accountService: AccountService, public prenota_service: PrenotazioneAppuntamentoService, private joyrideService: JoyrideService, protected configurazioneGeneraleService: ConfigurazioneGeneraleService) {
  }

  ngOnInit(): void {
    this.codiceServizio = this.activatedRoute.snapshot.queryParams["servizio"];
    this.ufficio = this.activatedRoute.snapshot.queryParams["ufficio"];
    this.accountService.identity().subscribe({
      next: (res) => {
        if(!res){
          this.isLoggedIn = false;
          this.goToInserimentoDatiPrenotazioneperUnaltro();
        }else{
          this.isLoggedIn = true;
        }
      },
      error: err => {
        this.isLoggedIn = false;
        this.goToInserimentoDatiPrenotazioneperUnaltro();
      }
    })
  }

  async goToInserimentoDatiPrenotazione(): Promise<void> {
    localStorage.removeItem('app');
    await this.setLocalStoragePerMe();
    if(this.codiceServizio && this.ufficio){
      this.prenota_service.callerPage = "Appuntamenti/prenota-nuovo-appuntamento?servizio=" +this.codiceServizio + "&ufficio=" + this.ufficio;
      await this.route.navigateByUrl('Appuntamenti/inserimento-dati-prenotazione?servizio='  +this.codiceServizio + "&ufficio=" + this.ufficio, {state: {isListaPrenotazioni: this.checkPreviousListaPrenotazioni()}});
    }else{
      this.prenota_service.callerPage = "Appuntamenti/prenota-nuovo-appuntamento";
      await this.route.navigate(['Appuntamenti/inserimento-dati-prenotazione'], {state: {isListaPrenotazioni: this.checkPreviousListaPrenotazioni()}});
    }
  }

  async goToInserimentoDatiPrenotazioneperUnaltro() : Promise<void> {
    // localStorage.removeItem('app');
    await this.setLocalStoragePerUnAltro();
    if(this.codiceServizio){
      this.prenota_service.callerPage = "Appuntamenti/prenota-nuovo-appuntamento?servizio=" +this.codiceServizio + "&ufficio=" + this.ufficio;
      await this.route.navigateByUrl('Appuntamenti/inserimento-dati-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + this.ufficio, {state: {isListaPrenotazioni: this.checkPreviousListaPrenotazioni()}});
    }else{
      this.prenota_service.callerPage = "Appuntamenti/prenota-nuovo-appuntamento";
      await this.route.navigate(['Appuntamenti/inserimento-dati-prenotazione'], {state: {isListaPrenotazioni: this.checkPreviousListaPrenotazioni()}});
    }

  }

  async setLocalStoragePerUnAltro(): Promise <void> {
    if (localStorage.getItem('userData') != null) {
      this.appuntamento = {
        richiedente: JSON.parse(localStorage.getItem('userData') || '{}'),
      };
      localStorage.setItem('app', JSON.stringify(this.appuntamento));
    } else {
      await this.route.navigate(['error'])
    }
  };

  async setLocalStoragePerMe(): Promise<void> {
    localStorage.removeItem('app');
    if (localStorage.getItem('userData') != null) {
      this.appuntamento = {
        dichiarante: JSON.parse(localStorage.getItem('userData') || '{}'),
        richiedente: JSON.parse(localStorage.getItem('userData') || '{}')
      };
      localStorage.setItem('app', JSON.stringify(this.appuntamento));
    } else {
      await this.route.navigate(['error'])
    }
  };

  onTour(): any {
    this.joyrideService.startTour({
      steps: ['primoStep', 'secondoStep']
    })
  }

  tornaIndietro(): void {
    if (window.history.state.previousRoute) {
      this.route.navigate([window.history.state.previousRoute])
    } else {
      this.route.navigate(['/home']);
    }
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  checkPreviousListaPrenotazioni():boolean{
    return window.history.state.previousRoute === 'Appuntamenti/lista-prenotazioni';
  }

  goToListaPrenotazioni():void{
    return void this.route.navigate(['Appuntamenti/lista-prenotazioni']).then();
  }
}
